import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { DescriptionTooltip } from '@/components/CustomAvatar';
import { NAV_MAP } from '@/hooks/useMenu/constants';

import styles from '../styles/index.module.less';

/** 云厂商官网式分类菜单：左侧切换分类，右侧只展示当前分类内容。 */
export function TutorialsDropdown({ desc, lists, onClose, title }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => setActiveIndex(0), [lists]);

  const activeList = lists[activeIndex] || lists[0];
  const items = activeList?.children?.length ? activeList.children : activeList ? [activeList] : [];

  const handleClick = (path) => {
    if (!path) return;
    if (path.startsWith('http')) window.open(path, '_blank');
    else navigate(path);
    onClose();
  };

  return (
    <div className={styles.menu_Contaner}>
      <div className={styles.menuInner}>
        <aside className={styles.categoryPanel}>
          <div className={styles.categoryHeader}>
            <strong>{NAV_MAP[title]?.title || title}</strong>
            {desc && <span>{desc}</span>}
          </div>
          <div className={styles.categoryList}>
            {lists.map((list, index) => (
              <button
                className={`${styles.categoryItem} ${activeIndex === index ? styles.categoryItemActive : ''}`}
                key={list.id || list.title}
                onMouseEnter={() => setActiveIndex(index)}
                onFocus={() => setActiveIndex(index)}
                type="button"
              >
                {NAV_MAP[list.title]?.title || list.title}
                <span aria-hidden>›</span>
              </button>
            ))}
          </div>
        </aside>

        <section className={styles.productPanel}>
          <div className={styles.productPanelTitle}>{NAV_MAP[activeList?.title]?.title || activeList?.title}</div>
          <div className={styles.productGrid}>
            {items.map((item) => (
              <button className={styles.productItem} key={item.id || item.title} onClick={() => handleClick(item.path)} type="button">
                <strong>{NAV_MAP[item.title]?.title || item.title}</strong>
                {(NAV_MAP[item.title]?.description || item.description) && (
                  <DescriptionTooltip description={NAV_MAP[item.title]?.description || item.description}>
                    <span>{NAV_MAP[item.title]?.description || item.description}</span>
                  </DescriptionTooltip>
                )}
              </button>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
